<template>
  <b-modal v-model="showModal">
    <div slot="modal-title">
      {{ $t('message.subscription.subscription_detail') }}
    </div>
    <subscription-detail/>
    <div slot="modal-footer" class="w-100">
      <b-btn class="float-right" variant="secondary" @click="showModal = false">
        {{ $t('message.button.close') }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import SubscriptionDetail from '../../../information/SubscriptionDetail'

  export default {
    components: {
      SubscriptionDetail
    },
    data () {
      return {
        showModal: false
      }
    },
    methods: {
      showSubscriptionDetailModal (status) {
        this.showModal = status
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/newSteps/components/SubscriptionDetailModal.vue